"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeApproval = exports.approvalRequestSchema = exports.nativeApprovalResultSchema = exports.nativeApprovalArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.nativeApprovalArgsSchema = zod_1.z.object({
    workflowId: zod_1.z.string().describe('The ID of the workflow'),
    nodeName: zod_1.z.string().describe('The name of the node requesting approval'),
    emitMode: common_1.emitModeSchema
        .default('single')
        .describe('Emit mode for the tool. Default to "single".'),
});
// Result schema
exports.nativeApprovalResultSchema = zod_1.z.object({
    approvalId: zod_1.z.string(),
    nodeName: zod_1.z.string(),
    status: zod_1.z.string(),
    message: zod_1.z.string(),
});
// Approval request schema
exports.approvalRequestSchema = zod_1.z.object({
    approvalId: zod_1.z.string(),
    workflowId: zod_1.z.string(),
    nodeName: zod_1.z.string(),
    approved: zod_1.z.boolean().optional(),
    timestamp: zod_1.z.string(),
});
// Tool definition
exports.nativeApproval = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeApproval',
    displayName: 'Request Approval',
    displayDescription: 'Request approval for a workflow step',
    category: 'native',
    color: common_1.BRAND_COLORS.APPROVAL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.APPROVAL),
    icon: 'approval',
    argsSchema: exports.nativeApprovalArgsSchema,
}, exports.nativeApprovalResultSchema);
